import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getConferenceIcons} from 'src/openapi/admin/apis/ConferenceIconsApi';
import {useAppDispatch} from 'src/store/hooks';

export const useGetConferenceIcons = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getConferenceIcons({signal}),
    ), [apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
